export default "__VITE_ASSET__BqqmECSU__"